import axios from "axios";
import {
  PROFILE_FETCH,
  SEARCH_FETCH,
  PROFILE_EDIT,
  FETCH_BY_SEARCH,
  PROFILE_STATUS_UPDATE,
} from "config/api-const";
import { actions } from "view/profile/store/slice";
import { actions as globalActions } from "store/slice";

export const fetchProfile = async (token, dispatch) => {
  if (!token) return;

  try {
    if (typeof token !== "string") {
      console.error("Token is not a string:", token);
      return;
    }
    const response = await axios.get(PROFILE_FETCH + token);
    if (response?.data?.success) {
      // Dispatch the profile data to Redux
      const {
        birthDetails,
        createdBy,
        contactDetails,
        familyDetails,
        horoscopeDetails,
        horoscopeImage,
        govtId,
        lookingFor,
        navamsaKatam,
        navamsaPlanets,
        occupation,
        ownHouse,
        personalInfo,
        qualification,
        rasiKatam,
        rasiPlanets,
        residentialAddress,
        startDate,
        currentUser,
        verificationDetails,
        eatingHabits,
        drinkingHabits,
        smokingHabits,
      } = response?.data?.values[0];

      if (currentUser) {
        dispatch(actions.setBirthDetails(birthDetails));
        dispatch(actions.setContactDetails(contactDetails));
        dispatch(actions.setFamilyDetails(familyDetails));
        dispatch(actions.setHoroscopeDetails(horoscopeDetails));
        dispatch(actions.setPersonalInfo(personalInfo));
        dispatch(actions.setOccupationDetails(occupation));
        
        // Normalize qualification to array format for backward compatibility
        // Backend stores as Object, but frontend uses Array
        const normalizedQualification = Array.isArray(qualification)
          ? qualification
          : qualification && Object.keys(qualification).length > 0
          ? [qualification]
          : [{ fieldOfStudy: "", degree: "" }];
        
        dispatch(actions.setQualification(normalizedQualification));
        dispatch(actions.setRasiKatam(rasiKatam));
        dispatch(actions.setRasiPlanets(rasiPlanets));
        dispatch(actions.setNavamsaKatam(navamsaKatam));
        dispatch(actions.setNavamsaPlanets(navamsaPlanets));
        dispatch(actions.setResidentialAddress(residentialAddress));
        dispatch(actions.setVerificationDetails(verificationDetails));
        dispatch(actions.setEatingHabits(eatingHabits));
        dispatch(actions.setDrinkingHabits(drinkingHabits));
        dispatch(actions.setsmokingHabits(smokingHabits));
        dispatch(actions.setProfileStatus(response?.data?.values[0]?.profileStatus || "active"));
        dispatch(
          actions.setProfileDetails({
            createdBy,
            horoscopeImage,
            govtId,
            lookingFor,
            ownHouse,
            startDate,
            eatingHabits,
            smokingHabits,
            drinkingHabits,
          })
        );
        dispatch(
          globalActions.setLoginSuccess({
            emailAddress: currentUser?.emailAddress,
            username: currentUser?.username,
            userId: currentUser?.userId,
          })
        );
      }
      return response.data; // Return the response if needed
    }
  } catch (err) {
    console.error("Error in fetchProfile. Try again later.\n", err);
  }
};

export const saveProfile = async (token, profile) => {
  const profileObj = profile;

  try {
    return await axios.post(PROFILE_EDIT, {
      profileObj,
      token,
    });
  } catch (err) {
    console.error("Opps, Error in Updating. Try after sometime later \n", err);
  }
};

export const updateProfileStatus = async (token, status) => {
  try {
    return await axios.post(PROFILE_STATUS_UPDATE, { token, status });
  } catch (err) {
    console.error("Error updating profile status:\n", err);
  }
};

export const fetchAllProfile = async (token, currentPage) => {
  try {
    return await axios.get(
      `${SEARCH_FETCH}?token=${token}&page=${currentPage}`
    );
  } catch (err) {
    console.error(
      "Opps, Error in fetchAllProfile. Try after sometime later \n",
      err
    );
  }
};
export const fetchAllProfileByFilter = async (
  token,
  search,
  minAge,
  maxAge,
  selectedRasis,
  sort,
  currentPage,
  profilesAvailability
) => {
  try {
    return await axios.get(
      `${SEARCH_FETCH}?token=${token}&search=${search}&minAge=${minAge}&maxAge=${maxAge}&rasi=${selectedRasis}&sort=${sort}&page=${currentPage}&profilesAvailability=${profilesAvailability}`
    );
  } catch (err) {
    console.error(
      "Opps, Error in fetchAllProfile. Try after sometime later \n",
      err
    );
  }
};

export const fetchAllProfileBySearch = async (token, search) => {
  try {
    return await axios.get(
      `${FETCH_BY_SEARCH}?token=${token}&search=${search}`
    );
  } catch (err) {
    console.error(
      "Opps, Error in fetchAllProfile. Try after sometime later \n",
      err
    );
  }
};
